import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function ProjectCreateNavigation({
  currentStep,
  onBack,
  onNext,
  canGoNext = true,
  nextLabel = 'Suivant →',
  hideNext = false,
}: {
  currentStep: number
  onBack?: () => void
  onNext?: () => void
  canGoNext?: boolean
  nextLabel?: string
  hideNext?: boolean
}) {
  const navigate = useNavigate()

  const handleBack = () => {
    if (onBack) {
      onBack()
      return
    }

    if (currentStep === 1) {
      navigate('/home')
      return
    }
  }

  return (
    <div className="flex items-center gap-4 pt-6">
      <Button type="button" variant="ghost" size="icon" data-testid="wizard-back-btn" onClick={handleBack} className="shrink-0">
        <ArrowLeft className="h-5 w-5" />
      </Button>

      {!hideNext && (
        <Button type="button" data-testid="wizard-next-btn" onClick={onNext} disabled={!canGoNext} className="flex-1 md:flex-initial md:min-w-[200px]">
          {nextLabel}
        </Button>
      )}
    </div>
  )
}
